import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Suggestion from './suggestion';
import ReactDOM from 'react-dom';
import { some } from 'lodash';
import styles from './typeahead.css';

export default class Suggestions extends React.Component {
  static propTypes = {
    parent: PropTypes.string,
    className: PropTypes.string,
    suggestionLists: PropTypes.arrayOf(
      PropTypes.shape({
        unique: PropTypes.string,
        title: PropTypes.string,
        suggestions: PropTypes.arrayOf(
          PropTypes.shape({
            type: PropTypes.string,
            icon: PropTypes.string,
            name: PropTypes.string.isRequired,
            route: PropTypes.string.isRequired
          })
        )
      })
    ),
    search: PropTypes.string
  };

  // makes the div scroll as suggestions are selected with the keyboard
  suggestionSelectedAtOffset(suggestionTop, suggestionHeight) {
    const node = ReactDOM.findDOMNode(this);
    const suggestionBottom = suggestionTop + suggestionHeight;
    const nodeHeight = node.getBoundingClientRect().height;
    if (suggestionTop < node.scrollTop) {
      node.scrollTop = 0;
    } else if (nodeHeight < suggestionBottom) {
      node.scrollTop = suggestionBottom - nodeHeight;
    }
  }

  renderSuggestions = suggestions => {
    const suggestionTypeToIcon = {
      location: 'pin',
      provider: 'company'
    };

    return suggestions.map(suggestion => {
      return (
        <Suggestion
          icon={suggestion.icon ? suggestion.icon : suggestionTypeToIcon[suggestion.type]}
          name={suggestion.name}
          route={suggestion.route}
          key={suggestion.route}
        />
      );
    });
  };

  containsSuggestions = suggestionLists => {
    return some(suggestionLists, list => {
      return list.suggestions.length;
    });
  };

  renderSuggestionLists() {
    const { suggestionLists } = this.props;

    if (this.containsSuggestions(suggestionLists)) {
      return suggestionLists.map(list => {
        if (list.title) {
          return (
            <ul key={list.unique}>
              <li>
                <h4 className={styles.listTitle}>{list.title}</h4>
                <ul>
                  {this.renderSuggestions(list.suggestions)}
                </ul>
              </li>
            </ul>
          );
        }
        return (
          <ul key={list.unique}>
            {this.renderSuggestions(list.suggestions)}
          </ul>
        );
      });
    }

    return (
      <div data-auto="noResults" className={styles.noResults}>
        Nothing was found for that query.
      </div>
    );
  }

  render() {
    return (
      <div
        data-parent={this.props.parent || null}
        className={classnames(styles.suggestions, this.props.className)}
        onMouseDown={ev => ev.preventDefault()}
      >
        {this.renderSuggestionLists()}
      </div>
    );
  }
}
